// One commercial unit classifier shared by Pricing producers, Stage 4 and
// downstream certification. A Pricing row may carry the legacy is_day_rate
// flag even when its free-text unit is terse; preserving that fact prevents a
// producer-accepted day rate from being rejected or billed hourly later.
export function isPerDayPricingUnit(unit, explicitDayRate = false) {
    if (explicitDayRate === true) return true;
    const value = String(unit || '').trim();
    return /(?:^|\b)(?:per\s*day|daily|day\s*rate)(?:\b|$)/i.test(value)
        || /^days?$/i.test(value);
}
